/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Tpl_Meta_DescInputs */

const en_fw_tpl_meta_desc = /** @type {(inputs: Fw_Tpl_Meta_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ready-made plans published by Bystep users after at least 5 of their tasks passed verification. Ranked by pass rate.`)
};

const id_fw_tpl_meta_desc = /** @type {(inputs: Fw_Tpl_Meta_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rencana siap pakai yang diterbitkan pengguna Bystep setelah minimal 5 task-nya lolos verifikasi. Diurutkan berdasarkan pass rate.`)
};

/**
* | output |
* | --- |
* | "Ready-made plans published by Bystep users after at least 5 of their tasks passed verification. Ranked by pass rate." |
*
* @param {Fw_Tpl_Meta_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const fw_tpl_meta_desc = /** @type {((inputs?: Fw_Tpl_Meta_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Tpl_Meta_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_fw_tpl_meta_desc(inputs)
	return en_fw_tpl_meta_desc(inputs)
});